import React, { ChangeEvent, useCallback } from 'react';
import { Checkbox } from '@app/form';

import { useDebouncedHandleChange } from './useDebounce';
import { useTranslation } from 'react-i18next';

interface Props {
  selectAll: () => any;
  selectNone: () => any;
  setValue: (val?: any) => void;
  filterValue: readonly any[];
  allValue: any[];
}

export const DeselectCheckbox = ({
  selectAll,
  selectNone,
  setValue,
  filterValue,
  allValue,
}: Props) => {
  const { t } = useTranslation();
  const handleSelectAllCheck = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.currentTarget;
      if (checked) {
        setValue(allValue);
        return selectAll();
      }
      if (!checked) {
        setValue([]);
        return selectNone();
      }
    },
    [selectAll, selectNone, allValue, setValue],
  );

  const debouncedHandleSelectAllChange =
    useDebouncedHandleChange(handleSelectAllCheck);

  return (
    <Checkbox
      label={t('participants.list.filters.selectAll')}
      noMargin
      checked={
        (filterValue && filterValue.length) === (allValue && allValue.length)
      }
      onChange={debouncedHandleSelectAllChange}
    />
  );
};
